/**
 * @generated SignedSource<<938e17f06ebef292c408912f4e3f8e99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleActionWidgetArticle$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "articleReactionArticle">;
  readonly " $fragmentType": "articleActionWidgetArticle";
};
export type articleActionWidgetArticle$key = {
  readonly " $data"?: articleActionWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleActionWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleActionWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleReactionArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "52a1af940934e8577d3d0c8c8d1792c4";

export default node;
